import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { assertUnreachable } from '../../../../ts/helpers/TypescriptHelpers';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { Databases } from '../../../../ts/resources/Databases';
import { Tables } from '../../../../ts/resources/Tables';
import { IResult } from '../../../../ts/ServerApi/types/IResponse';
import { ModalInstance, ReactModalService } from '../../../../ts/services/ReactModalService';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { SetCertificationAction } from '../../../actions/spaces/SetCertificationAction';
import { CertificationDialogProps, certificationDialogProps, CertificationDialogState } from '../../../content/CertificationDialog';
import { ServiceLocator } from '../../../ServiceLocator';
import { isSubmitOrCancelButtonClicked, SubmitOrCancelButtonClicked } from '../../../utils/SubmitOrCancel';
import { reloadSpaceIfUpdatingCurrentSpace } from './RefreshContentSagas';

export function* handleSetCertification(action: SetCertificationAction) {
  try {
    const result: SubmitOrCancelButtonClicked | any = yield call(openCertificationDialog, action);

    if (isSubmitOrCancelButtonClicked(result)) {
      switch (result) {
        case SubmitOrCancelButtonClicked.cancelled: break;
        case SubmitOrCancelButtonClicked.submitted: {
          const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.item]);
          if (!maybeReloaded) {
            yield put(requestSpaceContents());
          }
          break;
        }
        default: assertUnreachable(result);
      }
    }
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function setCertification(item: IContentInfo<'database'> | IContentInfo<'table'>, args: CertificationDialogState): Promise<IResult> {
  switch(item.contentType) {
    case 'database': return ServiceLocator.get<Databases>('Databases').setDatabaseCertification({
      certificationNote: args.certificationNote,
      isCertified: args.isCertified,
      id: item.vizportalId
    });
    case 'table': return ServiceLocator.get<Tables>('Tables').setTableCertification({
      certificationNote: args.certificationNote,
      isCertified: args.isCertified,
      id: item.vizportalId
    });
    default: assertUnreachable(item);
  }
}

export function openCertificationDialog(action: SetCertificationAction) {
  let modalInstance: ModalInstance<SubmitOrCancelButtonClicked>;

  const props: CertificationDialogProps = {
    initial: {
      isCertified: action.item.isCertified || false,
      certificationNote: action.item.certificationNote || '',
    },
    submit: (args: CertificationDialogState) => setCertification(action.item, args).then(() => modalInstance && modalInstance.close(SubmitOrCancelButtonClicked.submitted)),
    cancel: () => modalInstance && modalInstance.close(SubmitOrCancelButtonClicked.cancelled)
  };

  modalInstance = ReactModalService.open(certificationDialogProps(props));
  return modalInstance.result;
}
